import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { LabOSAuth, LABOS_APP_ID } from './lib/labos.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabOSAuth appId={LABOS_APP_ID}>
      <App />
    </LabOSAuth>
  </StrictMode>,
);
